<template>
  <div
    :class="containerClass"
    class="flex flex-col space-y-4 items-center"
  >
    <div
      v-for="n in lines"
      :key="n"
      class="relative w-full"
    >
      <div
        :class="[
          computedSize,
        ]"
        class="bg-gray-200 animate-shine w-full"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  lines?: number
  size?: 'lg' | 'md' | 'sm'
  shape?: 'text' | 'square' | 'event'
  containerClass?: string
}

const props = withDefaults(defineProps<Props>(), {
  lines: 1,
  size: 'md',
  shape: 'text',
  containerClass: '',
})

const computedSize = computed(() => {
  if (props.shape === 'text') {
    switch (props.size) {
      case 'lg':
        return 'h-[40px] pr-4'
      case 'sm':
        return 'h-6 pr-4'
      default:
        return 'h-4 pr-4'
    }
  }
  else {
    if (props.shape === 'square') {
      return 'h-full aspect-square w-full'
    }

    if (props.shape === 'event') {
      return 'relative aspect-[16/9] w-full flex-shrink-0'
    }
  }
})
</script>

<style type="pcss">
.animate-shine {
  position: relative;
  background: #eee;
  overflow: hidden;
  border-radius: 0.375rem; /* Rounded sm (adjustable) */
}

.animate-shine::before {
  content: '';
  position: absolute;
  top: 0;
  left: -75%;
  width: 150%;
  height: 100%;
  background-image: linear-gradient(
    90deg,
    #eee 0px,
    rgba(255, 255, 255, 0.4) 35%,
    #eee 70%
  );
  background-repeat: no-repeat;
  transform: skewX(-45deg);
  animation: shine 1.2s infinite;
}

@keyframes shine {
  0% {
    left: -75%;
  }
  100% {
    left: 100%;
  }
}
</style>
